module.exports = __webpack_public_path__ + "static/media/lemmy.9613c1e6.svg";